import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import UnpaidHistoryItem from "./UnpaidHistoryItem";
import {
  userState,
  indicatorState,
  payFailListState,
} from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import Loading from './../Loading';

function UnpaidHistory() {
  const user = useRecoilValue(userState);
  const [, setIndicator] = useRecoilState(indicatorState);
  const [payFailList, setPayFailList] = useRecoilState(payFailListState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIndicator("홈 > 결제실패 내역");

    const getHistoryList = async () => {
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/unpaid", {
          params: {
            id: user.company_id,
          },
        });
        if (data.code === "SUCCESS") {
          setPayFailList(data.data);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    };

    getHistoryList();
    // eslint-disable-next-line
  }, []);

  const onRepay = async (id, is_reservation) => {
    if (window.confirm("재결제 하시겠습니까?")) {
      try {
        setLoading(true);
        const params = new URLSearchParams({
          id: id,
          is_reservation: is_reservation
        });
        const { data } = await awsInstance.put(`/business/unpaid?${params}`);
        if (data.code === "SUCCESS") {
          setPayFailList(payFailList.filter((pay) => pay.id !== id));
          alert("재결제가 완료되었습니다.");
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert("재결제에 실패하였습니다.");
      } finally {
        setLoading(false);
      }
    } else {
      return false;
    }
  };

  return (
    <>
    <div className="unpaid_history">
      <h5 className="title">결제실패 내역</h5>
      <p className="txt-gray">
        카드 한도 증액 또는 카드 변경 후, 재결제 버튼을 클릭하면 재결제 할 수
        있습니다.
      </p>
      <div className="display-flex justify-content-between">
        <p className="txt-gray mt-3 font-bold">
          <span className="txt-blue">{payFailList.length}건</span>이 검색되었습니다.
        </p>
      </div>
      <div>
        <table className="table table-list">
          <tbody>
            <tr className="background-gray txt-white">
              <th className="width-9">
                <span>이용번호</span>
              </th>
              <th className="width-20">
                <span>탑승일시</span>
              </th>
              <th className="width-20">
                <span>직원 이메일</span>
              </th>
              <th className="width-7">
                <span>직원명</span>
              </th>
              <th className="width-9">
                <span>그룹명</span>
              </th>
              <th className="width-9">
                <span>이용요금</span>
              </th>
              <th className="width-10 p-0">
                <span className="p-0">결제실패 금액</span>
              </th>
            </tr>
            {payFailList.length !== 0 &&
              payFailList.map((value) => {
                return (
                  <UnpaidHistoryItem
                    key={value.id}
                    id={value.id}
                    history={value}
                    onRepay={onRepay}
                  />
                );
              })}
            {payFailList.length === 0 && (
              <>
                <tr>
                  <th colSpan="7">
                    <span className="txt-dark-gray">
                      결제실패 내역이 없습니다.
                    </span>
                  </th>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default UnpaidHistory;
